import * as React from 'react';
import type { WrappedFieldArrayProps } from 'redux-form';

import type { W_Account_FindForNotifyAll_VM } from 'ab-api/web/account/findForNotifyAll';

import type UserGroupRequestModel from 'ab-requestModels/userGroup.requestModel';

import type { CredentialFM } from '../formModel';
import Credential from './Credential';

interface OwnProps {
	userGroups: UserGroupRequestModel[];
	users: W_Account_FindForNotifyAll_VM['rows'];
}

type Props = OwnProps & WrappedFieldArrayProps<CredentialFM>;

const CredentialNotificationsForm: React.FC<Props> = (props) => {
	const { fields, userGroups, users } = props;

	const renderCredential = React.useCallback((fieldName: string, index: number) => {
		const field = fields.get(index);

		return (
			<Credential fieldName={fieldName} key={fieldName} name={field.name} userGroups={userGroups} users={users} />
		);
	}, [fields, userGroups, users]);

	return fields.map(renderCredential);
};

export type CredentialNotificationFieldArrayOwnProps = OwnProps;

export default React.memo(CredentialNotificationsForm);
